import { fetchFluxBotAction } from "@/api/endpoints/fluxbot";
import { SOL_MINT } from "@/shared";
import fetchWithAuth from "@/plugins/fetch";

export async function indexTradeOrders(wallet, mint: string): Promise<any> {
	const res = await fetchWithAuth(`https://gateway.fluxbeam.xyz/orders?trader=${wallet}&mint=${mint}&status=1`)

	const j = await res.json();

	if (!res.ok) {
		throw new Error(j?.error || res.statusText);
	}

	return j;
}

export async function createTradeOrders({
	wallet,
	src,
	dest,
	method,
	price,
	inAmount,
	delta,
	expiry,
}: {
	wallet: string;
	src: string;
	dest: string;
	method: number;
	price: number;
	inAmount: number;
	delta: number;
	expiry: number;
}): Promise<any> {
	return await fetchFluxBotAction(wallet, "lo_create", {
		source: src || SOL_MINT,
		dest: dest,
		method: method,
		amount: price,
		inAmount: Math.floor(inAmount),
		delta: delta,
		expiry: expiry,
	});
}

export async function closeTradeOrder(wallet, id: string): Promise<any> {
	return await fetchFluxBotAction(wallet, "lo_cancel", {
		data: id,
	});
}

export async function getTraderOrders({ wallet, status }: any): Promise<any> {
	const params = new URLSearchParams({
		trader: wallet,
		status,
	});
	return (
		await fetchWithAuth(`https://gateway.fluxbeam.xyz/orders?${params.toString()}`)
	).json();
}